import { createServerFn } from "@tanstack/react-start";
import { requireAdminRoleServer } from "./auth-server-fn-helper.server";

export const requireAdminRole = createServerFn({ method: "POST" })
  .validator((data: { data?: string } | string | undefined) => data)
  .handler(async (ctx) => {
    const input = (ctx as any).data;
    const token = typeof input === "object" && input !== null ? input.data : input;
    return await requireAdminRoleServer(token);
  });
